export enum PassengersPageId {
	Home = 'passengers-home',
	Blogs = 'blogs',
	Flights = 'flights',
	ShopDineRelax = 'shop-dine-and-relax',
	FlightDetail = 'flight-detail',
	NotFound = 'not-found',
	ParkingAvailability = 'parking-availability',
	Security = 'security',
	Map = 'map',
	NonStopDestinations = 'nonstop-destinations',
	Privacy = 'privacy-policy',
	WhereWeFly = 'voyager',
}

export enum BusinessPageId {
	Home = 'business-home',
	Newsroom = 'newsroom',
	NewsAndUpdates = 'news',
	PressReleases = 'press-releases',
	MediaResources = 'media-resources',
	MediaLibrary = 'media-library',
	MediaContacts = 'media-contacts',
}

export enum CareersPageId {
	Home = 'careers-home',
	Jobs = 'jobs',
}

export enum OXDPageId {
	Home = 'oxd-airport',
}

export enum GeneralPageId {
	Search = 'search',
}
